import React from "react";

const Pagination = ({
  total,
  currentPage,
  limit,
  updateLimit,
  nextPage,
  prePage,
  disableUpdatePageLimit,
}) => {
  return total ? (
    <div className="pagination-container">
      <div className="limit">
        <label>
          View{"  "}
          {disableUpdatePageLimit ? (
            `${limit}`
          ) : (
            <input
              className="amount-picker"
              type="number"
              value={limit}
              onChange={(event) => updateLimit(Number(event.target.value))}
            />
          )}
          {"  "} items per page
        </label>
      </div>
      <div className="current">
        {currentPage * limit + 1}-{Math.min(currentPage * limit + limit, total)}{" "}
        of {total}
      </div>
      <div className="controller">
        <ul>
          {currentPage < 1 ? null : (
            <li className="waves-effect right-arrow" onClick={prePage}>
              <i className="material-icons">chevron_left</i>
            </li>
          )}
          <li>
            <span>{currentPage + 1}</span>
          </li>
          {total <= currentPage * limit + limit ? null : (
            <li className="waves-effect left-arrow" onClick={nextPage}>
              <i className="material-icons">chevron_right</i>
            </li>
          )}
        </ul>
      </div>
    </div>
  ) : null;
};

export default Pagination;
